import React, { Fragment } from 'react'
import { graphql } from 'gatsby'

import { getProject } from '../../projects'
import {
  ProjectLayout,
  ProjectIntro,
  Title,
  Paragraph,
} from '../../layouts/project'

import { useNavbarTheme } from '../../contexts/NavbarTheme'

import { media } from '../../styles/tools'

import { AutoFade, AutoSlide } from '../../components/Animated'
import Wrapper from '../../components/Wrapper'
import Space from '../../components/Space'
import VideoPlayer from '../../components/VideoPlayer'

import Logo from '../../assets/pages/work/paramount-equity-mortgage/Logo.js'

export const query = graphql`
  {
    headerImage: file(
      relativePath: { eq: "pages/work/paramount-equity-mortgage.jpg" }
    ) {
      ...windowWide
    }
    facebookImage: file(
      relativePath: { eq: "pages/work/paramount-equity-mortgage.jpg" }
    ) {
      ...facebookShareImage
    }
    twitterImage: file(
      relativePath: { eq: "pages/work/paramount-equity-mortgage.jpg" }
    ) {
      ...twitterShareImage
    }
  }
`

let project = getProject('paramount-equity-mortgage')

export default ({ data }) => {
  project = {
    ...project,
    headerImage: data.headerImage.childImageSharp.fluid,
    facebookImage: data.facebookImage.childImageSharp.fixed.src,
    twitterImage: data.twitterImage.childImageSharp.fixed.src,
    logo: <Logo />,
  }

  useNavbarTheme('dark')

  return (
    <ProjectLayout project={project}>
      <ProjectIntro
        project={project}
        text={
          <Fragment>
            <AutoFade>
              <Title as="h1" css={{ maxWidth: '11em' }}>
                Branding the modern mortgage.
              </Title>
            </AutoFade>
            <Space y={32} />
            <AutoFade>
              <Paragraph>
                Paramount Equity Mortgage set out to revolutionize the mortgage
                industry in 2003 by delivering a service experience that is
                fast, easy, friendly and convenient. When comes to choosing a
                mortgage lender today, the consumer has too many choices.
                Rational benefits are simply not enough to break from the
                clutter. In order to succeed, Paramount needed a refined brand
                positioning - to be a brand that is differentiated and
                aspirational.
              </Paragraph>
            </AutoFade>
            <Space y={16} />
            <AutoFade>
              <Paragraph>
                Paramount’s goal was to stop telling consumers what they do and
                instead start telling them what they get and how it will make
                them feel.
              </Paragraph>
            </AutoFade>
          </Fragment>
        }
      >
        <Space y={{ mobile: 60, tablet: 100 }} />
        Intro
      </ProjectIntro>
      <Wrapper>
        <Space y="25vw" />
        <Space y={{ mobile: 80, tablet: 150 }} />
        Content
      </Wrapper>
    </ProjectLayout>
  )
}
